import { render, staticRenderFns } from "./CustomerNotEnrolled.vue?vue&type=template&id=2b8f840c&scoped=true&"
import script from "./CustomerNotEnrolled.vue?vue&type=script&lang=js&"
export * from "./CustomerNotEnrolled.vue?vue&type=script&lang=js&"
import style0 from "./CustomerNotEnrolled.vue?vue&type=style&index=0&id=2b8f840c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8f840c",
  null
  
)

export default component.exports